import { type Mileage, VehicleEnum, VehicleMileageRatePerKm } from "@finway-group/shared/lib/models"
import { toAmount, toDinero } from "@finway-group/shared/lib/utils"
import { type TFunction } from "i18next"
import { isNotSet } from "~Shared/utils/helper.utils"

const KILOMETER_DIVIDER = 1000

export const getVehicleString = (vehicle: VehicleEnum, t: TFunction) => {
    switch (vehicle) {
        case VehicleEnum.CAR:
            return t("label:mileage.vehicle_type.car")
        case VehicleEnum.MOTORCYCLE:
            return t("label:mileage.vehicle_type.motorcycle")
        default:
            return t("label:n/a")
    }
}

export const calculateExpensePriceFromDistanceAndVehicle = (vehicle: VehicleEnum, distance: number, rateOverride?: number) => {
    let pricePerKm = 0
    if (rateOverride || rateOverride === 0) {
        pricePerKm = rateOverride! // isSet should assert this to be NOT undefined.
    } else if (vehicle === VehicleEnum.CAR) {
        pricePerKm = VehicleMileageRatePerKm.CAR
    } else {
        pricePerKm = VehicleMileageRatePerKm.MOTORCYCLE
    }
    const price = toAmount(toDinero(Number(distance) * pricePerKm))
    return { totalGrossPrice: price, totalNetPrice: price, totalTaxPrice: 0 }
}

export const isDistanceOverThreshold = ({ expectedDistance, actualDistance }: Mileage, threshold: number) =>
    expectedDistance ? actualDistance > expectedDistance + threshold : false

const convertMeterToKilometer = (distanceInMeter: number) => distanceInMeter / KILOMETER_DIVIDER

export const roundDownToClosestInteger = (distance: number) => Math.floor(distance)

export const convertToKmAndRoundDistance = (distanceInMeter: number) => {
    if (isNotSet(distanceInMeter) || typeof distanceInMeter !== "number") {
        return undefined
    }
    return roundDownToClosestInteger(convertMeterToKilometer(distanceInMeter))
}
